import * as React from "react";
import { BusinessServiceDescriptor } from "src/businessServices";
import { Planning2Settings } from "./Planning2Settings";
import { loadPlanning2Settings, savePlanning2Settings } from "./apiPlanning2";
import { zPlanning2Settings } from "./ZPlanning2Settings";
import { Planning2Control } from "./Planning2Control";

export const bsPlanning2: BusinessServiceDescriptor = {
  key: "Planning2",
  viewer: (info, { entity }) => {
    if (!entity) return null;
    return <Planning2Control objectServiceId={info.id} mainEntity={entity} />;
  },
  renderSettings: (info, store) => (
    <Planning2Settings
      typesMap={store.attrTypesDict}
      objList={store.treeData.filter((it) => it.type === "obj")}
      mainObjectId={info.objectId}
    />
  ),
  loadSettings: async (info) => loadPlanning2Settings(info.id),

  async saveSettings(info, values) {
    const settings = zPlanning2Settings.parse(values);
    await savePlanning2Settings(info.id, settings);
  },

  // TODO: С этим пока не очень понятно
  // functions: [
  //   {
  //     functionName: "massCreatePlans",
  //     menuItem: (params) => <BulkPlanCreation {...params} />,
  //   },
  // ],
};
